enum CalendarEventLabelType {
  Default,
  Mobile,
  New,
  Preview,
}

export default CalendarEventLabelType
